import Head from 'next/head';
import Image from 'next/image';
import PageHero from '../shared-components/PageHero';
import client from '../apollo-client';
import FEATUREDEXPERIENCES from '../api/featuredexperiences';
import { FEATURED_EXPERIENCES_INTERFACE } from '../api/featuredexperiences';
import { HOMEPAGE, HOMEPAGEINTERFACE } from '../api/homePage';
import LandingPage from '../components/Landingpage/landingpage';
import dynamic from 'next/dynamic';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';
const Newsletter = dynamic(() => import('../layouts/Newsletter/Newsletter'));
interface IProps {
  featuredExp: any;
  citydropdown: any;
  HomePage: any;
}
export default function Home({ featuredExp, citydropdown, HomePage }: IProps) {
  const router = useRouter();
  useEffect(() => {
    router.push('/');
  }, []);
  return (
    <>
      <Head>
        <meta
          name="og:title"
          content="See Sight Tours - Top-Rated Small Group Tours in North America"
        />
        <meta
          name="og:description"
          content={HomePage?.homePage?.metaDescription}
        />
        <title>See Sight Tours - Best Small Group Tours</title>
        <meta
          name="description"
          content={HomePage?.homePage?.metaDescription}
        />
        <meta
          name="og:image"
          content="https://res.cloudinary.com/see-sight-tours/image/upload/v1598548912/see-sight-tours-logo-stacked.png"
        />
        <link rel="canonical" href={HomePage?.homePage?.canonical} />
      </Head>
      {process.env.NEXT_PUBLIC_MODE === 'LIVE' && (
        <Script
          src="https://static.elfsight.com/platform/platform.js"
          async
          id="widget-elf"
        ></Script>
      )}
      <main className="pb-16">
        <section id="hero" className="relative">
          <Image
            src="/Map_Background.png"
            alt="Map Background"
            width={1920}
            height={1080}
            priority
            className="absolute inset-0 w-full object-cover z-0"
          />

          <PageHero
            title={HomePage?.homePage?.header}
            snippet={HomePage?.homePage?.subheader}
            media={HomePage?.homePage?.banner_media}
          />
        </section>

        <LandingPage
          featuredExp={featuredExp}
          citydropdown={citydropdown}
          HomePage={HomePage}
        />

        <Newsletter />
      </main>
    </>
  );
}

export async function getStaticProps() {
  const { data } = await client.query<FEATURED_EXPERIENCES_INTERFACE>({
    query: FEATUREDEXPERIENCES,
    variables: {
      dayTours: false,
      multiday: false,
      airportTransfers: false
    }
  });
  const { data: HomePage } = await client.query<HOMEPAGEINTERFACE>({
    query: HOMEPAGE,
    variables: {
      guides: false
    }
  });

  return {
    props: {
      featuredExp: data.homePage,
      citydropdown: data.citiesDropdown,
      HomePage: HomePage
    }
  };
}
